import React, { ChangeEvent, useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import itemImg from './../../../../../assets/icons/team.png'
import Cancel from './../../../../../assets/icons/close.png'
import galleryIcon from './../../../../../assets/icons/upload.png'
import AutoCompleteMultiSelect from './../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import TextAreaComponents from './../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddCorporateMenuItem from './AddCorporateMenuItem/AddCorporateMenuItem.tsx'
import TimingComponenet from '../../../../components/TimingComponenet/TimingComponenet.tsx'
import SchedulerComponent from '../../SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx'

function AddCorporateMenuDialog(props) {
    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const [open, setOpen] = React.useState(false);
    const [items, setitems] = React.useState([]);
    const onHandleAddItem = (AddItemData) => {
        console.log("AddItemData: " + AddItemData);
        setOpen(false)
        if (AddItemData != false) {
            items.push(AddItemData);
            console.log("items: " + AddItemData.addonsItem[0].title);
            console.log("items: " + items[0].addonsItem[0].title);
        }

    }


    const [state, setState] = React.useState<ImageUploadState>({
        selectedImages: [],
    })

    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if (files) {
            const imagesArray: string[] = []
            const remainingSlots = 5 - state.selectedImages.length
            const filesToUpload = Array.from(files).slice(0, remainingSlots)
            for (let i = 0; i < filesToUpload.length; i++) {
                const file = filesToUpload[i]
                const reader = new FileReader()
                reader.onloadend = () => {
                    imagesArray.push(reader.result as string)
                    if (imagesArray.length === filesToUpload.length) {
                        const updatedImages = [...state.selectedImages, ...imagesArray]
                        setState({ selectedImages: updatedImages })
                    }
                }
                reader.readAsDataURL(file)
            }
        }
    }

    const handleDeleteImage = (index: number) => {
        const updatedImages = [...state.selectedImages]
        updatedImages.splice(index, 1)
        setState({ selectedImages: updatedImages })
    }

    const sectionDatas = [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
    ]
    const addValue = (props) => {
        console.log(props)
        // setAutoCompleteValue(props)
    }
    const [radiovalue, setRadioValue] = React.useState('Specify');
    const [isactive, setIsactive] = React.useState(false);
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadioValue((event.target as HTMLInputElement).value);
        if ((event.target as HTMLInputElement).value === "Hot") {
            var Vatprice = 3 / 100;
            var total = Vatprice * priceExclusive;
            setVatAmount(total)
            setvatInAmount(3);
            setIsactive(true);
            setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
        }
        else if ((event.target as HTMLInputElement).value === "Cold") {
            var Vatprice = 0 / 100;
            var total = Vatprice * priceExclusive;
            setVatAmount(total)
            setvatInAmount(0);
            setIsactive(true);
            setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
        }
        else {
            setIsactive(false);
        }
    };
    const [switchCheck, setswitchCheck] = React.useState(false)
    const [selectDay, setSelectDay] = React.useState(true);
    const [mselectDay, setMSelectDay] = React.useState(true);
    const [TselectDay, setTSelectDay] = React.useState(true);
    const [WselectDay, setWSelectDay] = React.useState(true);
    const [T1selectDay, setT1SelectDay] = React.useState(true);
    const [FselectDay, setFSelectDay] = React.useState(true);
    const [SselectDay, setSSelectDay] = React.useState(true);
    const textFieldValue = (props) => {
        console.log(props)
        // setAutoCompleteValue(props)
    }
    const [priceExclusive, setPriceExclusive] = React.useState(0);
    const setpriceExclusiveval = (props) => {
        console.log(props)
        setPriceExclusive(props)
    }

    const [vatAmount, setVatAmount] = React.useState(0);
    const [vatInAmount, setvatInAmount] = React.useState(0);
    const [priceInclusive, setpriceInclusive] = React.useState(0);
    const inAmountVATValue = (props) => {
        console.log(props)
        var Vatprice = props * 100;
        var total = Vatprice / priceExclusive;
        setvatInAmount(total)
        setVatAmount(props);
        setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
    }


    const inPercentageVATValue = (props) => {
        console.log(props)
        var Vatprice = props / 100;
        var total = Vatprice * priceExclusive;
        setVatAmount(total)
        setvatInAmount(props);
        setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
    }
    const TimingValue = (props) => {
        console.log(props)

    }
    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={8}>
                            <DialogTitle>
                                <div className='d-flex' style={{ gap: "8px" }}>
                                    <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div>

                                    <span style={{ color: "#2a7fd4" }}>GoTaste :-  Add corporate menu for Pot Kettle Black Manchester</span>
                                </div></DialogTitle>
                        </Grid>
                        <Grid item xs={4}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Corporate Name
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={'Corporate Name'} value={textFieldValue} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }} >
                                <Typography style={{ paddingTop: '1rem' }} >
                                    <span onClick={() => setOpen(true)}>Add Item</span>
                                </Typography>

                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }} >
                                <table className='table table-hover'>
                                    <thead>
                                        <tr>
                                            <th>Item Name</th>
                                            <th>Addons</th>
                                            <th>Quantity</th>
                                            <th>Portion Size</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            items.map((name, index) =>
                                                <tr>
                                                    <td key={index}>{name.ItemName}</td>
                                                    <td>
                                                        {items[index].addonsItem.map((addons, addonsindex) => { return (<span>{addons.title},</span>) })}
                                                    </td>
                                                    <td >{name.quantity}</td>
                                                    <td >{name.portionSize}</td>
                                                </tr>
                                            )}


                                    </tbody>
                                </table>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Price (Exclusive)
                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <TextAreaComponents id={2} label={'Price (Exclusive)'} value={setpriceExclusiveval} />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    VAT (Amount)
                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={radiovalue}
                                    onChange={handleRadioChange}
                                >
                                    {/* <FormControlLabel value="Hot" control={<Radio />} label="Hot" />
                                    <FormControlLabel value="Cold" control={<Radio />} label="Cold" /> */}
                                    <FormControlLabel value="Specify" control={<Radio />} label="Specify" />
                                </RadioGroup>
                                <div >
                                    <Grid container>
                                        <Grid xs={6}>
                                            <TextAreaComponents id={2} label={'VAT (%)'} value={inPercentageVATValue} val={vatInAmount} isactive={isactive} />
                                        </Grid>
                                        <Grid xs={5} className='ms-2'>
                                            <TextAreaComponents id={2} label={'VAT (Amount)'} value={inAmountVATValue} val={vatAmount} isactive={isactive} />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Price (Inclusive)
                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <TextAreaComponents id={2} label={'Price (Inclusive)'} value={textFieldValue} val={priceInclusive} />
                            </Grid>
                        </Grid>
                        {/* <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Min Quantity
                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <TextAreaComponents id={2} label={'Min Quantity'} value={textFieldValue} />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Max Quantity
                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <TextAreaComponents id={2} label={'Max Quantity'} value={textFieldValue} />
                            </Grid>
                        </Grid> */}
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Available Time
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                {/* <TimingComponenet selectedData={TimingValue}></TimingComponenet> */}
                                <SchedulerComponent></SchedulerComponent>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Is Active
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <Switch
                                    checked={switchCheck}
                                    onChange={() => { setswitchCheck(!switchCheck) }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Image
                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    //   color="primary"
                                    className='uploadButton'
                                // style={{ backgroundColor: 'white', color: 'gray' }}
                                >
                                    <img
                                        src={galleryIcon}
                                        alt="photo"
                                    // style={{ width: '2rem' }}
                                    />
                                    Upload
                                    <input
                                        hidden
                                        accept="image/*"
                                        multiple
                                        type="file"
                                        onChange={handleImageUpload}
                                        disabled={state.selectedImages.length >= 5}
                                    />
                                </Button>
                            </Grid>

                            {/* image show start */}
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={9}>
                                    <Grid container spacing={2}>
                                        {state.selectedImages.map((image, index) => (
                                            <Grid item xs={2} sm={2} md={2} key={index}>
                                                {/* <Paper> */}
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        paddingTop: '20px',
                                                    }}
                                                >
                                                    <img
                                                        src={image}
                                                        alt={`Preview ${index + 1}`}
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                    <IconButton
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-6px',
                                                            right: '-23px',
                                                            color: 'gray',
                                                        }}
                                                        onClick={() => handleDeleteImage(index)}
                                                    >
                                                        <CancelIcon />
                                                    </IconButton>
                                                </div>
                                                {/* </Paper> */}
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* image show end */}
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="">Save</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
            <AddCorporateMenuItem open={open}
                onHandleAddItem={onHandleAddItem}
                title={props.title} />
        </div>
    );
}

export default AddCorporateMenuDialog;